import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { PortfolioContentFour } from "./projectFour/PortfolioContentFour";

export const PortfolioArcThurrock = () => {
  return (
    <div>
      <NavBar />
      <PortfolioContentFour />
      <Footer />
    </div>
  );
};
